// types/index.ts
export interface LoginCredentials {
  username: string;
  password: string;
}

export interface AuthResponse {
  success: boolean;
  token: string;
  user: User;
}

export enum UserRole {
  ADMIN = 'admin',
  OWNER = 'owner',
  MANAGER = 'manager',
  STAFF = 'staff',
  RECEPTIONIST = 'receptionist',
  CUSTOMER = 'customer'
}

export interface User {
  id: string | number;
  username?: string; // Made optional as MainLayout uses name
  name: string;      // Made required as MainLayout relies on it
  email?: string;
  role: UserRole | string;
  permissions?: string[];
}


// Booking interface (giữ nguyên của bạn)
export interface Booking {
  id: string;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  bookingDate: Date;
  serviceType: string;
  numberOfPeople: number;
  specialRequests?: string;
  status: 'pending' | 'confirmed' | 'cancelled' | 'completed';
  createdAt: Date;
  employeeId?: string;
}

// Employee interface (giữ nguyên của bạn)
export interface Employee {
  id: string;
  name: string;
  email: string;
  phone: string;
  position: string;
  isActive: boolean;
  workingHours: {
    start: string;
    end: string;
  };
  maxBookingsPerDay: number;
}

// DashboardStats interface (giữ nguyên của bạn)
export interface DashboardStats {
  totalBookings: number;
  pendingBookings: number;
  todayBookings: number;
  totalEmployees: number;
  monthlyRevenue: number;
}

// Thêm các types mới cho Recent Activities
export interface RecentActivity {
  id: string;
  type: 'booking' | 'employee' | 'payment';
  description: string;
  userId: string;
  userName: string;
  createdAt: string;
}